"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _CardActions = _interopRequireDefault(require("@material-ui/core/CardActions"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _colors = require("@material-ui/core/colors");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _RootRef = _interopRequireDefault(require("@material-ui/core/RootRef"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _i18n = require("../../../../Framework/i18n");
var _AnalyticsWrapper = _interopRequireDefault(require("../Analytics/AnalyticsWrapper"));
var _customClassName = _interopRequireDefault(require("../../../Utils/customClassName"));
var _MainButton = _interopRequireDefault(require("../../../../Shared/Components/MainButton"));
var _PriceOverview = _interopRequireDefault(require("../PriceOverview"));
var _Notification = _interopRequireDefault(require("../Notification"));
var _PriceList = _interopRequireDefault(require("../PriceList"));
var _AddToBasket = _interopRequireDefault(require("../AddToBasket"));
var _ReceiveOfferForm = _interopRequireDefault(require("../ReceiveOfferForm"));
var _AcceptDesign = _interopRequireDefault(require("../AcceptDesign"));
var _LoadingOverlay = _interopRequireDefault(require("../../../../Framework/Components/LoadingOverlay"));
var _utils = require("@material-ui/core/utils");
var _AcceptPrivacy = _interopRequireDefault(require("../AcceptPrivacy"));
var _ConfigurationOverview = _interopRequireDefault(require("../ConfigurationOverview"));
var _isMobileDevice = require("../../../../Framework/Helpers/isMobileDevice");
var _excluded = ["onTouchMove"],
  _excluded2 = ["wrapperClass", "renderPriceBox"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _contentPositioning, _card, _MuiDialogActions, _MuiDialogTitleRo, _AmountPriceButton, _mainButtonLabel, _closeIcon;
  return {
    contentPositioning: (_contentPositioning = {
      paddingLeft: 32,
      paddingRight: 20
    }, _defineProperty(_contentPositioning, theme.breakpoints.down('xs'), {
      paddingLeft: 0,
      paddingRight: 8,
      marginRight: '-8px'
    }), _defineProperty(_contentPositioning, '& p', {
      fontSize: 15,
      letterSpacing: 'normal'
    }), _defineProperty(_contentPositioning, "marginRight", 4), _defineProperty(_contentPositioning, "padding", 0), _contentPositioning),
    dialogWrapper: _defineProperty({
      borderTop: '7px solid ' + theme.palette.primary.main,
      padding: '0 32px',
      overflow: 'hidden'
    }, theme.breakpoints.down('xs'), {
      padding: '0 16px'
    }),
    card: (_card = {
      marginBottom: 1,
      borderTop: '7px solid ' + theme.palette.primary.main,
      padding: 15,
      overflow: 'visible'
    }, _defineProperty(_card, theme.breakpoints.between('xs', 'lg'), {
      marginTop: 16
    }), _defineProperty(_card, theme.breakpoints.down('xs'), {
      overflow: 'hidden',
      display: 'flex',
      boxShadow: 'none',
      '&:last-child': {
        padding: '12px 0 0'
      },
      paddingTop: 0,
      borderTop: '1px solid ' + _colors.grey[500],
      borderRadius: 0
    }), _card),
    cardUnboxed: _defineProperty({
      borderTop: 'none',
      boxShadow: 'none'
    }, theme.breakpoints.down('xs'), {
      display: 'flex'
    }),
    cardContentWrapper: _defineProperty({}, theme.breakpoints.down('xs'), {
      '&:last-child': {
        paddingBottom: 4
      }
    }),
    AmountPriceContent: {
      padding: 0,
      '&:last-child': {
        paddingBottom: 5
      }
    },
    dialogPositioning: {
      overflow: 'hidden',
      '& .MuiDialog-container': {
        '& .MuiDialogTitle-root': {
          paddingTop: 25,
          paddingBottom: 15,
          '& p, h2': {
            fontSize: 24,
            fontWeight: 'bold',
            letterSpacing: 'normal'
          }
        },
        '& .MuiDialogActions-root': (_MuiDialogActions = {
          paddingBottom: 24
        }, _defineProperty(_MuiDialogActions, theme.breakpoints.down('xs'), {
          marginRight: 0
        }), _defineProperty(_MuiDialogActions, "marginRight", 8), _MuiDialogActions),
        '& .MuiDialogTitle-root, .MuiDialogActions-root': (_MuiDialogTitleRo = {
          paddingLeft: 32,
          paddingRight: 20,
          marginRight: 4
        }, _defineProperty(_MuiDialogTitleRo, theme.breakpoints.down('xs'), {
          paddingLeft: 0,
          paddingRight: 0
        }), _defineProperty(_MuiDialogTitleRo, '& p', {
          fontSize: 15,
          letterSpacing: 'normal'
        }), _MuiDialogTitleRo)
      },
      '& .MuiButton-root': _defineProperty({
        height: 40,
        textTransform: 'none',
        minWidth: 140,
        marginTop: 8,
        color: theme.palette.primary.darkText
      }, theme.breakpoints.down('xs'), {
        height: 56
      })
    },
    AmountPriceButton: (_AmountPriceButton = {
      textTransform: 'none',
      whiteSpace: 'nowrap',
      margin: 0,
      padding: '6px 15px'
    }, _defineProperty(_AmountPriceButton, theme.breakpoints.down('xs'), {
      minWidth: 35,
      padding: 0
    }), _defineProperty(_AmountPriceButton, "color", theme.palette.primary.darkText), _AmountPriceButton),
    smallButtonSize: _defineProperty({}, theme.breakpoints.down('xs'), {
      fontSize: 12,
      lineHeight: 1
    }),
    mainButton: _defineProperty({
      margin: 0,
      padding: '6px 15px',
      height: 40,
      lineHeight: 1.5
    }, theme.breakpoints.down('xs'), {
      height: 56
    }),
    mainButtonLabel: (_mainButtonLabel = {}, _defineProperty(_mainButtonLabel, theme.breakpoints.down('xs'), {
      whiteSpace: 'normal',
      fontSize: 12
    }), _defineProperty(_mainButtonLabel, "whiteSpace", 'nowrap'), _mainButtonLabel),
    AmountPriceTypography: _defineProperty({
      textAlign: 'end',
      lineHeight: 1.2
    }, theme.breakpoints.down('xs'), {
      padding: '3px 0',
      textAlign: 'start',
      fontSize: 12,
      lineHeight: 1
    }),
    AmountPriceTypographyVat: _defineProperty({
      fontSize: 9,
      lineHeight: 1.2,
      textAlign: 'end',
      display: 'block'
    }, theme.breakpoints.down('xs'), {
      fontSize: 9,
      textAlign: 'start'
    }),
    cardActions: _defineProperty({
      padding: '8px 0'
    }, theme.breakpoints.down('xs'), {
      padding: 0
    }),
    closeIcon: (_closeIcon = {
      position: 'absolute',
      right: 32,
      top: 32
    }, _defineProperty(_closeIcon, theme.breakpoints.down('xs'), {
      right: 16
    }), _defineProperty(_closeIcon, '&:hover', {
      cursor: 'pointer'
    }), _closeIcon),
    configurationButton: {
      '&:hover': {
        cursor: 'pointer'
      },
      fontWeight: 'bold',
      textTransform: 'none',
      padding: '6px 15px',
      marginRight: '5px'
    },
    summary: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 5
      }
    },
    dialogTitleRoot: {
      padding: '20px 0'
    }
  };
};
var DialogActionsWrapper = function DialogActionsWrapper(_ref) {
  var onTouchMove = _ref.onTouchMove,
    props = _objectWithoutProperties(_ref, _excluded);
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var current = ref.current;
    if (current) {
      current.addEventListener('touchmove', onTouchMove, {
        passive: false
      });
    }
    return function () {
      if (current) {
        current.removeEventListener('touchmove', onTouchMove, {
          passive: false
        });
      }
    };
  }, [onTouchMove]);
  return (
    /*#__PURE__*/
    // as of material-ui v3.x the refs are not forwarded, so the only way to get it is using RootRef
    // FIXME check after updating material-ui
    _react["default"].createElement(_RootRef["default"], {
      rootRef: ref
    }, /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], props))
  );
};
var AmountPrice = /*#__PURE__*/function (_React$Component) {
  _inherits(AmountPrice, _React$Component);
  var _super = _createSuper(AmountPrice);
  function AmountPrice() {
    var _this;
    _classCallCheck(this, AmountPrice);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      showPriceOverview: false,
      showConfigurationOverview: false,
      notice: '',
      hasErrorReceiveOfferForm: false,
      bulkNameErrors: [],
      approval: {
        value: false,
        error: null
      },
      inView: true,
      showErrors: false,
      dataPrivacyAccepted: false
    });
    _defineProperty(_assertThisInitialized(_this), "receiveOfferFormComponentRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "dialogContentRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "priceListRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "acceptDesignRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "acceptDataPrivacyRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState(_defineProperty({}, event.target.name, {
        value: event.target.checked,
        error: null
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "verifyRequestErrors", function (hasFormValidationErrors) {
      var _this$props = _this.props,
        bulkNameErrors = _this$props.bulkNameErrors,
        displayAcceptDesign = _this$props.displayAcceptDesign;
      var designApproved = _this.state.approval.value;
      if (bulkNameErrors && bulkNameErrors.length > 0) {
        _this.setState({
          showErrors: true
        });
        _this.setState({
          bulkNameErrors: bulkNameErrors
        });
        _this.dialogContentRef.current.scrollTo(0, 0);
      }
      if (displayAcceptDesign && !designApproved) {
        _this.setState({
          approval: {
            value: false,
            error: true
          }
        });
        !hasFormValidationErrors && _this.acceptDesignRef.current && _this.acceptDesignRef.current.scrollIntoView();
      }
      if (!_this.dataPrivacyApproved()) {
        _this.setState({
          dataPrivacyAccepted: {
            value: false,
            error: true
          }
        });
        !hasFormValidationErrors && _this.acceptDataPrivacyRef.current && _this.acceptDataPrivacyRef.current.scrollIntoView();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "requestHasErrors", function () {
      var _this$props2 = _this.props,
        bulkNameErrors = _this$props2.bulkNameErrors,
        displayAcceptDesign = _this$props2.displayAcceptDesign;
      var designApproved = _this.state.approval.value;
      if (bulkNameErrors && bulkNameErrors.length > 0 || displayAcceptDesign && !designApproved || !_this.dataPrivacyApproved()) {
        return true;
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "onAddToBasket", function () {
      var onAddToBasket = _this.props.onAddToBasket;
      if (!_this.requestHasErrors()) {
        onAddToBasket();
      } else {
        _this.verifyRequestErrors();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "dataPrivacyApproved", function () {
      var _this$props3 = _this.props,
        showReceiveOfferForm = _this$props3.showReceiveOfferForm,
        clientTexts = _this$props3.clientTexts;
      var dataPrivacyLink = clientTexts.dataPrivacyLink;
      var dataPrivacyApproved = _this.state.dataPrivacyAccepted.value;
      return !dataPrivacyLink || !showReceiveOfferForm || dataPrivacyApproved;
    });
    _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function (evt) {
      var dialogContent = _this.dialogContentRef.current;
      evt.preventDefault();
      dialogContent.scrollTo(0, dialogContent.scrollTop);
    }.bind(_assertThisInitialized(_this)));
    _defineProperty(_assertThisInitialized(_this), "openPriceOverview", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _this.props.validateConfiguration();
          case 3:
            _this.setState({
              showPriceOverview: !_this.state.showPriceOverview,
              hasErrorReceiveOfferForm: false
            });
            _context.next = 9;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.warn("Error while validating configuration: ".concat(_context.t0));
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "openConfigurationOverview", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _this.props.validateConfiguration();
          case 3:
            _this.setState({
              showConfigurationOverview: true,
              hasErrorReceiveOfferForm: false
            });
            _context2.next = 9;
            break;
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            // eslint-disable-next-line no-console
            console.warn("Error while validating configuration: ".concat(_context2.t0));
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 6]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "onAddToCartClick", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!_this.props.skipPriceOverview) {
              _context3.next = 17;
              break;
            }
            _context3.prev = 1;
            _this.props.toggleGlobalLoader(true);
            _context3.next = 5;
            return _this.props.validateConfiguration();
          case 5:
            _context3.next = 7;
            return _this.props.onAddToBasket();
          case 7:
            return _context3.abrupt("return", _context3.sent);
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](1);
            // eslint-disable-next-line no-console
            console.warn("Error while validating configuration: ".concat(_context3.t0));
          case 13:
            _context3.prev = 13;
            _this.props.toggleGlobalLoader(false);
            return _context3.finish(13);
          case 16:
            return _context3.abrupt("return");
          case 17:
            return _context3.abrupt("return", _this.openPriceOverview());
          case 18:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 10, 13, 16]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        showConfigurationOverview: false,
        showPriceOverview: false,
        bulkNameErrors: [],
        approval: {
          value: false,
          error: null
        },
        showErrors: false
      });
      _this.props.onClose();
    });
    _defineProperty(_assertThisInitialized(_this), "onReceiveOfferFormPress", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var formValidation, result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            formValidation = _this.receiveOfferFormComponentRef.current.validate();
            if (!(!_this.requestHasErrors() && formValidation)) {
              _context4.next = 9;
              break;
            }
            _context4.next = 4;
            return _this.props.sendReceiveOfferRequest(formValidation);
          case 4:
            result = _context4.sent;
            if (!result) {
              _this.setState({
                hasErrorReceiveOfferForm: true
              });
              _this.dialogContentRef.current.scrollTo(0, 0);
            }
            if (result) {
              _this.setState({
                hasErrorReceiveOfferForm: false
              });
            }
            _context4.next = 10;
            break;
          case 9:
            _this.verifyRequestErrors(formValidation.hasError);
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    _defineProperty(_assertThisInitialized(_this), "setConfigurationCommentDebounced", (0, _utils.debounce)(function (value) {
      return _this.props.setConfigurationComment(value);
    }, 700));
    _defineProperty(_assertThisInitialized(_this), "handleBasketNoticeChange", function (event) {
      _this.setState({
        notice: event.target.value
      });
      _this.setConfigurationCommentDebounced(event.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectableChanged", function (priceData) {
      return function (key, newSelected) {
        var nextData = priceData.map(function (currentElement) {
          if (currentElement.key === key) {
            return _objectSpread(_objectSpread({}, currentElement), {}, {
              selected: newSelected,
              price: newSelected ? '10,00 €' : '0,00 €'
            });
          }
          return currentElement;
        });
        _this.setState({
          priceData: nextData
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "priceListClick", function () {
      _this.priceListRef.current.scrollIntoView();
    });
    _defineProperty(_assertThisInitialized(_this), "showPriceListButton", function (inView) {
      _this.setState({
        inView: inView
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderDefaultPriceBox", function () {
      var _this$props4 = _this.props,
        classes = _this$props4.classes,
        amount = _this$props4.amount,
        boxed = _this$props4.boxed,
        priceFormatted = _this$props4.priceFormatted,
        hidePrices = _this$props4.hidePrices,
        hidePieces = _this$props4.hidePieces,
        vatNotice = _this$props4.vatNotice,
        showReceiveOfferForm = _this$props4.showReceiveOfferForm,
        showCallToAction = _this$props4.showCallToAction,
        showConfigurationModeSwitch = _this$props4.showConfigurationModeSwitch,
        ConfigurationModeSwitchComponent = _this$props4.ConfigurationModeSwitchComponent,
        isCreator = _this$props4.isCreator;
      var isMobile = (0, _isMobileDevice.isMobileDevice)();
      var boxStyle = boxed ? classes.card : classes.cardUnboxed;
      return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        className: (0, _clsx["default"])(boxStyle, (0, _customClassName["default"])('cta-box'))
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 3,
        sm: 12
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        className: classes.cardContentWrapper,
        classes: {
          root: classes.AmountPriceContent
        }
      }, isCreator && !isMobile && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        className: classes.summary
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "list_alt"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: classes.configurationButton,
        variant: "text",
        size: "small",
        onClick: _this.openConfigurationOverview
      }, (0, _i18n.t)('amountPrice.configurationOverview')))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, !hidePieces && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 5,
        lg: 5
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "text",
        size: "small",
        onClick: _this.openPriceOverview,
        classes: {
          root: classes.AmountPriceButton,
          sizeSmall: classes.smallButtonSize
        }
      }, amount, " ", (0, _i18n.t)('amountPrice.pieces'))), !hidePrices && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 7,
        lg: 7
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "h5",
        classes: {
          root: classes.AmountPriceTypography
        }
      }, /*#__PURE__*/_react["default"].createElement("b", null, priceFormatted)), priceFormatted && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: classes.pos,
        variant: "caption",
        classes: {
          root: classes.AmountPriceTypographyVat
        }
      }, /*#__PURE__*/_react["default"].createElement("i", null, vatNotice)))))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 9,
        sm: 12
      }, /*#__PURE__*/_react["default"].createElement(_CardActions["default"], {
        className: classes.cardActions
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 1
      }, showConfigurationModeSwitch && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: showCallToAction ? 6 : 12
      }, /*#__PURE__*/_react["default"].createElement(ConfigurationModeSwitchComponent, {
        className: (0, _customClassName["default"])('configuration-type-button'),
        classes: {
          root: classes.mainButton,
          label: classes.mainButtonLabel
        }
      })), showCallToAction && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: showConfigurationModeSwitch ? 6 : 12
      }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "add_to_cart"
      }, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
        className: (0, _customClassName["default"])('cta-button'),
        variant: "contained",
        fullWidth: true,
        size: "medium",
        onClick: _this.onAddToCartClick,
        classes: {
          root: classes.mainButton,
          label: classes.mainButtonLabel
        }
      }, (0, _i18n.t)(showReceiveOfferForm ? 'receiveOfferForm.sendButton' : 'amountPrice.intoCart'))))))));
    });
    return _this;
  }
  _createClass(AmountPrice, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props5 = this.props,
        error = _this$props5.error,
        bulkNameErrors = _this$props5.bulkNameErrors;
      if (error && !(0, _isEqual["default"])(error, prevProps.error) && this.dialogContentRef.current) {
        this.dialogContentRef.current.scrollTo(0, 0);
      }
      if (bulkNameErrors !== prevProps.bulkNameErrors) {
        this.setState({
          bulkNameErrors: bulkNameErrors
        });
      }
      if (prevProps.addToCartPopUpLoader && !this.props.addToCartPopUpLoader) {
        this.handleClose();
      }
      var showPriceOverview = this.state.showPriceOverview;
      if (showPriceOverview !== prevState.showPriceOverview) {
        var onShowChange = this.props.onShowChange;
        onShowChange && onShowChange(showPriceOverview);
      }
      var showConfigurationOverview = this.state.showConfigurationOverview;
      if (showConfigurationOverview !== prevState.showConfigurationOverview) {
        var _onShowChange = this.props.onShowChange;
        _onShowChange && _onShowChange(showConfigurationOverview);
      }
      if (this.state.notice === prevState.notice && this.props.userComment !== this.state.notice) {
        this.setState({
          notice: this.props.userComment
        });
      }
    }
  }, {
    key: "renderConfigurationOverview",
    value: function renderConfigurationOverview() {
      var showConfigurationOverview = this.state.showConfigurationOverview;
      var _this$props6 = this.props,
        ConfigurationOverviewComponent = _this$props6.ConfigurationOverviewComponent,
        userConfiguration = _this$props6.userConfiguration,
        width = _this$props6.width,
        classes = _this$props6.classes;
      return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        classes: {
          paper: classes.dialogWrapper,
          container: width === 'md' || width === 'xs' ? classes.dialogPositioning : '',
          root: classes.dialogPositioning
        },
        BackdropProps: {
          className: classes.dialogPositioning
        },
        onClose: this.handleClose.bind(this),
        open: showConfigurationOverview,
        fullWidth: true,
        fullScreen: width === 'sm' || width === 'xs',
        scroll: "paper"
      }, /*#__PURE__*/_react["default"].createElement(_LoadingOverlay["default"], {
        show: this.props.addToCartPopUpLoader
      }), /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
        classes: {
          root: classes.dialogTitleRoot
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1"
      }, /*#__PURE__*/_react["default"].createElement("b", null, (0, _i18n.t)('amountPrice.configurationOverview'))), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: classes.closeIcon,
        onClick: this.handleClose.bind(this)
      }, "close")), /*#__PURE__*/_react["default"].createElement(_RootRef["default"], {
        rootRef: this.dialogContentRef
      }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
        classes: {
          root: classes.contentPositioning
        }
      }, /*#__PURE__*/_react["default"].createElement(ConfigurationOverviewComponent, {
        optionclassifications: userConfiguration.optionclassifications
      }))));
    }
  }, {
    key: "renderPriceOverview",
    value: function renderPriceOverview() {
      var _this2 = this;
      var _this$state = this.state,
        notice = _this$state.notice,
        showPriceOverview = _this$state.showPriceOverview,
        approval = _this$state.approval,
        inView = _this$state.inView,
        showErrors = _this$state.showErrors,
        bulkNameErrors = _this$state.bulkNameErrors,
        dataPrivacyAccepted = _this$state.dataPrivacyAccepted;
      var _this$props7 = this.props,
        amount = _this$props7.amount,
        priceList = _this$props7.priceList,
        priceFormatted = _this$props7.priceFormatted,
        onSelectableChanged = _this$props7.onSelectableChanged,
        showProductVariants = _this$props7.showProductVariants,
        ProductVariantComponent = _this$props7.ProductVariantComponent,
        error = _this$props7.error,
        width = _this$props7.width,
        hidePrices = _this$props7.hidePrices,
        title = _this$props7.title,
        classes = _this$props7.classes,
        showReceiveOfferForm = _this$props7.showReceiveOfferForm,
        vatNotice = _this$props7.vatNotice,
        clientTexts = _this$props7.clientTexts,
        displayAcceptDesign = _this$props7.displayAcceptDesign,
        notifications = _this$props7.notifications,
        showCallToAction = _this$props7.showCallToAction,
        ReceiveOfferFormComponent = _this$props7.ReceiveOfferFormComponent,
        AcceptDesignComponent = _this$props7.AcceptDesignComponent,
        PriceOverviewComponent = _this$props7.PriceOverviewComponent,
        NotificationComponent = _this$props7.NotificationComponent,
        PriceListComponent = _this$props7.PriceListComponent,
        AddToCartComponent = _this$props7.AddToCartComponent,
        AcceptPrivacyComponent = _this$props7.AcceptPrivacyComponent;
      var termsAndConditionsLink = clientTexts.termsAndConditionsLink,
        dataPrivacyLink = clientTexts.dataPrivacyLink;
      var mergedNotifications = _toConsumableArray(notifications) || [];
      if (showErrors && bulkNameErrors && bulkNameErrors.length > 0) {
        bulkNameErrors.map(function (error) {
          mergedNotifications.push({
            message: error,
            level: 'error',
            color: 'error'
          });
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        classes: {
          paper: classes.dialogWrapper,
          container: width === 'md' || width === 'xs' ? classes.dialogPositioning : '',
          root: classes.dialogPositioning
        },
        BackdropProps: {
          className: classes.dialogPositioning
        },
        onClose: this.handleClose.bind(this),
        open: showPriceOverview,
        maxWidth: 'md',
        fullWidth: true,
        fullScreen: width === 'sm' || width === 'xs',
        scroll: "paper"
      }, /*#__PURE__*/_react["default"].createElement(_LoadingOverlay["default"], {
        show: this.props.addToCartPopUpLoader
      }), /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
        classes: {
          root: classes.dialogTitleRoot
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1"
      }, /*#__PURE__*/_react["default"].createElement("b", null, (0, _i18n.t)(showReceiveOfferForm ? 'receiveOfferForm.sendButton' : 'amountPrice.intoCart'))), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: classes.closeIcon,
        onClick: this.handleClose.bind(this)
      }, "close")), /*#__PURE__*/_react["default"].createElement(_RootRef["default"], {
        rootRef: this.dialogContentRef
      }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
        classes: {
          root: classes.contentPositioning
        }
      }, this.state.hasErrorReceiveOfferForm && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        color: "error",
        variant: "body2"
      }, (0, _i18n.t)('receiveOfferForm.checkInputsInForm')), /*#__PURE__*/_react["default"].createElement(PriceOverviewComponent, {
        title: (0, _i18n.t)('amountPrice.productVariants'),
        contactData: (0, _i18n.t)('amountPrice.contactData'),
        handleClose: this.handleClose,
        amount: amount,
        acceptDesignComponent: showCallToAction ? /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.acceptDesignRef
        }, /*#__PURE__*/_react["default"].createElement(AcceptDesignComponent, {
          termsAndConditionsLink: termsAndConditionsLink,
          displayAcceptDesign: displayAcceptDesign,
          handleChangeCheckboxApproval: this.handleChange,
          approval: approval,
          closeProductOverviewDialog: this.handleClose,
          notice: notice,
          noteLabel: (0, _i18n.t)('amountPrice.notice'),
          handleChange: this.handleBasketNoticeChange
        })) : null,
        acceptDataPrivacyComponent: showReceiveOfferForm && dataPrivacyLink ? /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.acceptDataPrivacyRef
        }, /*#__PURE__*/_react["default"].createElement(AcceptPrivacyComponent, {
          dataPrivacyLink: dataPrivacyLink,
          displayAcceptDesign: true,
          handleChangeCheckboxApproval: this.handleChange,
          approval: dataPrivacyAccepted,
          closeProductOverviewDialog: this.handleClose,
          displayNote: false
        })) : null,
        notificationComponent: mergedNotifications.map(function (_ref6, key) {
          var message = _ref6.message,
            level = _ref6.level,
            color = _ref6.color;
          return /*#__PURE__*/_react["default"].createElement(NotificationComponent, {
            key: key,
            icon: level,
            color: color,
            notification: message
          });
        }),
        priceListComponent: /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.priceListRef
        }, /*#__PURE__*/_react["default"].createElement(_reactIntersectionObserver.InView, {
          as: "div",
          onChange: function onChange(inView) {
            return _this2.showPriceListButton(inView);
          }
        }, /*#__PURE__*/_react["default"].createElement(PriceListComponent, {
          amount: amount,
          list: priceList,
          totalPrice: priceFormatted,
          taxNote: (0, _i18n.t)('amountPrice.vatNotice'),
          onSelectableChanged: onSelectableChanged,
          hidePrices: hidePrices,
          showReceiveOfferForm: showReceiveOfferForm,
          productTitle: title
        }))),
        productVariantComponent: showProductVariants && /*#__PURE__*/_react["default"].createElement(ProductVariantComponent, null),
        receiveOfferFormComponent: /*#__PURE__*/_react["default"].createElement(ReceiveOfferFormComponent, {
          innerRef: this.receiveOfferFormComponentRef
        }),
        showReceiveOfferForm: showReceiveOfferForm
      }))), /*#__PURE__*/_react["default"].createElement(DialogActionsWrapper, {
        onTouchMove: this.handleTouchMove
      }, /*#__PURE__*/_react["default"].createElement(AddToCartComponent, {
        buttonLabel: (0, _i18n.t)(showReceiveOfferForm ? 'receiveOfferForm.sendButton' : 'amountPrice.intoCart'),
        showCallToAction: showCallToAction,
        onPress: showReceiveOfferForm ? this.onReceiveOfferFormPress : this.onAddToBasket,
        handleChange: this.handleBasketNoticeChange,
        disabled: !!error,
        totalPrice: priceFormatted,
        taxNote: vatNotice,
        showPriceList: !inView,
        priceListLabel: (0, _i18n.t)('amountPrice.showPriceList'),
        priceListClick: this.priceListClick,
        hidePrices: hidePrices,
        amount: amount,
        showReceiveOfferForm: showReceiveOfferForm
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
        wrapperClass = _this$props8.wrapperClass,
        renderPriceBox = _this$props8.renderPriceBox,
        props = _objectWithoutProperties(_this$props8, _excluded2);
      var _this$state2 = this.state,
        showPriceOverview = _this$state2.showPriceOverview,
        showConfigurationOverview = _this$state2.showConfigurationOverview;
      var openPriceOverview = this.openPriceOverview,
        openConfigurationOverview = this.openConfigurationOverview,
        renderDefaultPriceBox = this.renderDefaultPriceBox;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: wrapperClass
      }, renderPriceBox ? renderPriceBox(_objectSpread(_objectSpread({}, props), {}, {
        openPriceOverview: openPriceOverview,
        openConfigurationOverview: openConfigurationOverview,
        renderDefaultPriceBox: renderDefaultPriceBox
      })) : this.renderDefaultPriceBox(), showPriceOverview && this.renderPriceOverview(), showConfigurationOverview && this.renderConfigurationOverview());
    }
  }]);
  return AmountPrice;
}(_react["default"].Component);
_defineProperty(AmountPrice, "defaultProps", {
  showCallToAction: true,
  showConfigurationModeSwitch: false,
  notifications: [],
  clientTexts: {
    termsAndConditionsLink: ''
  },
  hidePieces: false,
  ReceiveOfferFormComponent: _ReceiveOfferForm["default"],
  AcceptDesignComponent: _AcceptDesign["default"],
  PriceOverviewComponent: _PriceOverview["default"],
  ConfigurationOverviewComponent: _ConfigurationOverview["default"],
  NotificationComponent: _Notification["default"],
  PriceListComponent: _PriceList["default"],
  AddToCartComponent: _AddToBasket["default"],
  AcceptPrivacyComponent: _AcceptPrivacy["default"],
  skipPriceOverview: false
});
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'AmountPrice'
})(AmountPrice));